import { CommonModule } from '@angular/common';
import { Component, OnInit, HostListener } from '@angular/core';
import { NgxMarqueeModule } from 'ngx-marquee';

interface Logo {
  src: string;
  alt: string;
}

@Component({
  selector: 'app-clients',
  standalone: true,
  imports: [NgxMarqueeModule, CommonModule],
  templateUrl: './clients.component.html',
  styleUrl: './clients.component.scss'
})
export class ClientsComponent implements OnInit {
  logos: Logo[] = [
    { src: 'assets/gifs/insurance-surgery.jpg', alt: 'Insurance Surgery' },
    { src: 'assets/gifs/Cura-Insurance.jpg', alt: 'Cura Insurance' },
    { src: 'assets/gifs/lifesearchlogo.png', alt: 'LifeSearch' },
    { src: 'assets/gifs/moneysworth.png', alt: 'Money Worth' }
  ];

  onImageError(event: any): void {
    console.error('Image failed to load:', event.target.src);
    // Show fallback text instead of hiding
    const logoItem = event.target.parentElement;
    const fallback = logoItem.querySelector('.logo-fallback');
    if (fallback) {
      fallback.style.display = 'block';
    }
    event.target.style.display = 'none';
  }

  ngOnInit() {
    this.initializeAnimations();
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.checkScrollAnimations();
  }

  private initializeAnimations() {
    // Set logo indices for staggered animation
    setTimeout(() => {
      const logoItems = document.querySelectorAll('.logo-item');
      logoItems.forEach((item, index) => {
        (item as HTMLElement).style.setProperty('--logo-index', index.toString());
      });
    }, 100);

    // Initialize intersection observer for animations
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, {
      threshold: 0.3,
      rootMargin: '0px 0px -50px 0px'
    });

    // Observe elements for animation
    setTimeout(() => {
      const elements = document.querySelectorAll('.clients-section, .clients-headline, .client-logos-carousel, .clients-content, .feature-item, .feature-icon');
      elements.forEach(element => {
        observer.observe(element);
      });
    }, 200);
  }

  private checkScrollAnimations() {
    const section = document.querySelector('.clients-section') as HTMLElement;
    if (section) {
      const rect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      if (rect.top < windowHeight * 0.8 && rect.bottom > windowHeight * 0.2) {
        section.classList.add('animate-in');
      }
    }
  }
}
